import _merge from 'lodash/merge'

// This is default config
// It merges with questions.contacts.config.fields (form's config)

export default ({ config }) => _merge({
  name: {
    dataKey: 'name',
    inputType: 'text',
    label: 'Name',
    placeholder: 'Enter name',
  },
  email: {
    dataKey: 'email',
    inputType: 'text',
    label: 'Email',
    placeholder: 'user@example.edu',
    config: { type: 'email' },
  },
  phone: {
    dataKey: 'phone',
    inputType: 'text',
    label: 'Phone',
    placeholder: '(555) 555-5555',
    config: { type: 'tel' },
  },
  address: {
    inputType: 'text',
    dataKey: 'address',
    label: 'Address',
    placeholder: 'Set Contact Address',
    class: 'm-2 mb-4',
  },
  notify: {
    dataKey: 'notify',
    inputType: 'yesNo',
    label: 'Send Email Notifications',
  },
}, config.fields)
